import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MaterialForm from "./MaterialForm";
import { getEditMaterial, getMaterialById } from "../../../api/materialService";
import { getErrorMessage } from "../../../utils/errorHandler"
import FullPageLoader from "../../../common/FullPageLoader";

export default function EditMaterial() {
  const location = useLocation();
  const id = location?.state?.materialId;
  const navigate = useNavigate();

  const [material, setMaterial] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [backendErrors, setBackendErrors] = useState({});

  useEffect(() => {
    fetchMaterial();
  }, []);

  const fetchMaterial = async () => {
    try {
      const response = await getMaterialById(id);
      setMaterial(response?.data || response);
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    } finally {
      setPageLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
  try {
    setLoading(true);

    const response = await getEditMaterial(id, formData);
    
    setMessage(response?.message || "Material updated successfully");
if (response?.success === false || response?.status === 422) {
        setBackendErrors(response?.error || {});
        return;
      }
    setTimeout(() => {
      navigate("/material");
    }, 1500);
  } catch (error) {
    console.error(error);
    setMessage(getErrorMessage(error));
  } finally {
    setLoading(false);
  }
};

  if (pageLoading) {
    return <FullPageLoader text="Loading material..." />;
  }

  return (
    <div className="container-fluid p-4">
      <div className="card p-4">
        
         {message && (
      <div
        className={`alert ${
          message.toLowerCase().includes("success")
            ? "alert-success"
            : "alert-danger"
        }`}
      >
        {message}
      </div>
    )}

        <MaterialForm
          initialValues={material}
          onSubmit={handleSubmit}
          loading={loading}
          backendErrors={backendErrors}
          buttonText="Update Material"
        />
      </div>
    </div>
  );
}
